<template>
	<BaseContainer
		class="dnnCloud-account-box"
		:loading="listLoading"
		:isHasPageFt="!listLoading"
	>
		<template v-slot:hd>
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px">
				<el-form :inline="true" :model="souchs" @submit.native.prevent>
					<el-form-item>
						<el-select
							v-model="souchs.value1"
							placeholder="请选择"
							style="width: 160px"
						>
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select
							v-model="souchs.value2"
							placeholder="请选择"
							style="width: 160px"
						>
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select
							v-model="souchs.value3"
							placeholder="请选择"
							style="width: 160px"
						>
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-input
							v-model="souchs.input"
							placeholder="请输入内容"
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button
							type="primary"
							size="medium"
							v-on:click="check()"
							>查询</el-button
						>
						<el-button
							type="primary"
							size="medium"
							v-on:click="add()"
							>新增</el-button
						>
					</el-form-item>
				</el-form>
			</el-col>
			<target-custom-dialog
				ref="targetcustomdialogRef"
			></target-custom-dialog>
		</template>
		<template v-slot:main>
			<div class="tips">
				<span>目标客户总数量：</span
				><span class="blueNumber">600</span>
				<span>甲级目标客户总数量：</span
				><span class="redNumber">600</span>
			</div>

			<el-table
				:data="tableData"
				style="width: 100%"
				:height="maxTbHeight - 36"
				highlight-current-row
				:header-cell-style="getRowClass"
				@sort-change="handleSortChange"
			>
				<el-table-column
					type="index"
					:index="indexMethod"
					label="序号"
					width="80"
				>
				</el-table-column>
				<el-table-column
					prop="date"
					label="日期"
					sortable
					width="180"
					show-overflow-tooltip
				>
				</el-table-column>
				<el-table-column
					prop="name"
					label="姓名"
					sortable
					width="180"
					show-overflow-tooltip
				>
				</el-table-column>
				<el-table-column
					prop="address"
					label="地址"
					show-overflow-tooltip
				>
				</el-table-column>
			</el-table>
		</template>
		<template v-slot:ft>
			<el-pagination
				layout="sizes, prev, pager, next"
				:page-sizes="[10, 20, 30, 50, 100]"
				:current-page="pageNumber"
				@current-change="handleCurrentChange"
				@size-change="handleSizeChange"
				:page-size="pageSize"
				:total="total"
				style="float: right"
			>
			</el-pagination>
		</template>
	</BaseContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseContainer from '@/components/BaseContainer'
import fitTableHeight from '@/mixins/fitTableHeight.js'
import TargetCustomDialog from './targetCustomDialog.vue'
export default {
	mixins: [fitTableHeight],
	data() {
		return {
			listLoading: false,
			options: [
				{
					value: '选项1',
					label: '黄金糕',
				},
				{
					value: '选项2',
					label: '双皮奶',
				},
				{
					value: '选项3',
					label: '蚵仔煎',
				},
				{
					value: '选项4',
					label: '龙须面',
				},
				{
					value: '选项5',
					label: '北京烤鸭',
				},
			],
			souchs: {
				value1: '',
				value2: '',
				value3: '',
				input: '',
			},

			tableData: [
				{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄',
				},
				{
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄',
				},
				{
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
				{
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄',
				},
			],
			pageNumber: 1,
			pageSize: 10,
			total: 50,
		}
	},
	computed: {
		...mapGetters(['userInfo']),
	},

	components: {
		BaseContainer,
		TargetCustomDialog,
	},

	mounted() {},
	methods: {
		check() {
			console.log('check')
		},
		add() {
			console.log('add')
			this.$refs.targetcustomdialogRef.init()
		},
		indexMethod(index) {
			return index + 1
		},
		handleCurrentChange(val) {
			this.pageNumber = val
		},
		handleSizeChange(val) {
			this.pageSize = val
		},
		getRowClass({ row, column, rowIndex, columnIndex }) {
			if (rowIndex == 0) {
				return 'background:#F5F7FA'
			} else {
				return ''
			}
		},
		handleSortChange(val) {
			console.log('handleSortChange', val)
		},
	},
}
</script>

<style scoped lang="scss">
.tips {
	font-size: 14px;
	line-height: 22px;
	color: #666666;
	margin-bottom: 14px;
	.blueNumber {
		color: #669df0;
		margin-right: 32px;
	}
	.redNumber {
		color: #eb6264;
	}
}
</style>



// WEBPACK FOOTER //
// targetCustom.vue?3a08e546